import { Component, OnInit,ViewChild } from '@angular/core';
import { LocationService } from 'app/shared/services/location.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ngx-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {

  displayedColumns: string[] = ['Location', 'CreatedBy','Action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  location : string;
  locationList : any;

  constructor(
              private locationService : LocationService, 
              private route : ActivatedRoute, 
              private dialogService : DialogService,
              private authService: AuthService,
              private router : Router, 
              private toastr: ToastrService,
              private themeService: NbThemeService,
              public dialogRef: MatDialogRef<LocationComponent>
             ) { }

  ngOnInit() {

    this.getAllLocations();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
		  
    
  }

 

    onClose(){
      this.dialogRef.close();
     }


    getAllLocations(){
    this.locationService.getAll()
     .subscribe(
        (data) => {
                  this.locationList = data;
                  this.dataSource = new  MatTableDataSource (this.locationList);  
                  this.dataSource.paginator = this.paginator;      
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   
     addLocationBtnClick(){
    
        if (this.location){
          const formData = {
            location : this.location,
            createdBy : this.authService.getUserLoggedIn()
          }
    
            this.locationService.create(formData)
              .subscribe(
                (res) => {
    
                  if(res.success === 0){
                    this.toastr.error(res.message, 'warning');
                  }else if(res.success === 1){
                    this.toastr.success('Record created successfully', 'Success');
                    this.getAllLocations();
                    this.location = null;
                  }
                             
                },
                (err) => {
                  this.toastr.error('Failed to add item category', 'Failure');
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
              
        }else {  
            this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
        }
    
    
      }





     deleteButtonClick(id : string){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.locationService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('Deleted successfully','Success');
                      this.getAllLocations();    
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }



}
